import React from 'react';
import GeneralStatus from '../../GeneralStatus';
import { getTitleColorHex } from '../../constants/titleColors';

/**
 * Mobile Player Advisor Component
 * Positioned at bottom-right, mirrored position of general
 */
export const MobilePlayerAdvisor = ({
  you,
  playerDamageFlash,
  selectedAdvisor,
  avatars,
  getAvatarImage,
  shouldMirrorAvatar,
  activeGameState,
  activeUserId
}) => {
  return (
    <div className="player-advisor-container-mobile" style={{ 
      position: "absolute", 
      right: "5px",
      bottom: "45px",
      zIndex: 1000,
      transform: "scale(0.4)",
      transformOrigin: "bottom right"
    }}>
      <div style={{ position: "relative" }}>
        {/* Player Compact Intelligence Bar and Orb */}
        <GeneralStatus
          health={you.health}
          intelligenceLeft={you.intelligence}
          intelligenceTotal={you.maxIntelligence}
          barriersRemoved={you.barriersRemoved ?? []}
          damageFlash={playerDamageFlash}
          playerCompactIntelligence={true}
        />
        
        <img 
          src={getAvatarImage(selectedAdvisor)} 
          alt="Player Advisor" 
          style={{ 
            width: "180px", 
            height: "180px", 
            objectFit: "contain",
            transform: shouldMirrorAvatar(selectedAdvisor, 'right', avatars) ? 'scaleX(-1)' : 'none'
          }} 
        />
        
        {/* Title Display - Overlay at bottom of Advisor Avatar */}
        <div style={{
          position: "absolute",
          bottom: "0px",
          left: "90px",
          transform: "translateX(-50%)",
          width: "fit-content",
          textAlign: "center",
          color: getTitleColorHex(activeGameState?.playerTitleColors?.[activeUserId]),
          fontSize: "16px",
          fontWeight: "bold",
          textShadow: "1px 1px 2px rgba(0, 0, 0, 0.8)",
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          padding: "4px 8px",
          borderRadius: "4px",
          whiteSpace: "nowrap",
          zIndex: 10001,
          pointerEvents: "none"
        }}>
          {activeGameState?.playerTitles?.[activeUserId] || 'The undecided'}
        </div>
      </div>
    </div>
  );
};

export default MobilePlayerAdvisor;

